import { FileAction } from "./file-action";


export class PreviewFileAction extends FileAction {

    override execute(val: any, row: any): void {
        const preview = (file: Blob) => window.open(URL.createObjectURL(file), '_blank');
        super.execute(val, row, preview);
    }


}
